import React, { createContext } from 'react'
import { createContextualCan } from '@casl/react'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { useAbility } from './ability'

const AbilityContext = createContext()
const Can = createContextualCan(AbilityContext.Consumer)

const CanAbilityProvider = ({ children }) => {
  const { subscription, activeRole } = useAuthSelector()
  const { Roles } = activeRole || {}
  const roles = Roles || []

  const isSubscriptionActive = subscription?.SubscriptionStatus === 'Active'
  const allowedModules = isSubscriptionActive
    ? subscription?.Tier?.IncludedModules || []
    : []
  const ability = useAbility(allowedModules, roles)

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  )
}

export { CanAbilityProvider, Can }
